import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ContainerController } from './container.controller';
import { Container } from './container.entity';
import { ContainerService } from './container.service';
import { ContainerLogRepository } from './repository/container-log.repository';
import { ContainerRepository } from './repository/container.repository';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ContainerAdapter } from './dto/container.adapter';
import { ContainerLogAdapter } from './dto/container-log.adapter';
import { DestinationService } from '@gtpl/shared-services/masters';
import {DocumentsListService} from '@gtpl/shared-services/logistics'
import { StockService } from '@gtpl/shared-services/procurement';
import { FGStockService } from '@gtpl/shared-services/warehouse-management';
import {  WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';


@Module({
  imports: [
    TypeOrmModule.forFeature([ContainerRepository, ContainerLogRepository]),
  ],
  controllers: [ContainerController],
  providers: [ContainerService, SaleOrderService,StockService, ApplicationExceptionHandler, ContainerAdapter, ContainerLogAdapter, DestinationService,DocumentsListService,FGStockService,WhatsappBroadCastService,WhatsAppNotificationService]
})
export class ContainerModule {}
